import React from 'react';
import $ from 'jquery';
import StringUtils from '../../utils/stringutils.js';

class SGQuestion extends React.Component {

	constructor(props) {
		super(props);

		this.onInputChanged = this.onInputChanged.bind(this);
		this.onFileSelect = this.onFileSelect.bind(this);

	}

	componentDidMount() {
		//var comp = this;
		$('#file-upload-' + this.props.dataId).off().on('changed', function(e){
			
		});
	}

	onFileSelect(e) {
		this.props.onAnswer(this.props.dataId, e.currentTarget.files[0]);
	}

	onInputChanged(e) {
		switch(this.props.response_type) {
			case 'textarea':
				this.props.onAnswer(this.props.dataId, e.currentTarget.value);
				break;
			case 'textinput':
				this.props.onAnswer(this.props.dataId, e.currentTarget.value);
				break;
			case 'numinput':
				this.props.onAnswer(this.props.dataId, e.currentTarget.value);
				break;
			case 'checkbox':
				var checkedVals = [];
				$.map($('[name=' + this.props.dataId + ']:checked'), function(val, i) {
					checkedVals.push($(val).attr('id'));
				});
				this.props.onAnswer(this.props.dataId, checkedVals);
				break;
			case 'file':
				$('#file-upload-' + this.props.dataId).click();
				break;
			default:
				break;
		}
	}

	getReadableFileSizeString(fileSizeInBytes) {
	    var i = -1;
	    var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
	    do {
	        fileSizeInBytes = fileSizeInBytes / 1024;
	        i++;
	    } while (fileSizeInBytes > 1024);

	    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
	}

	render() {
		var answerContent = '';

		switch(this.props.response_type) {
			case 'textarea':
				answerContent = (
					<div className="SG-Question-Answer-Area">
						<textarea rows="8" cols="40" onChange={this.onInputChanged} value={this.props.answer} />
					</div>
					);
				break;
			case 'textinput':
				answerContent = (
					<div className="SG-Question-Answer-Area">
						<input type="text" onChange={this.onInputChanged} value={this.props.answer} />
					</div>
					);
				break;
			case 'numinput':
				answerContent = (
					<div className="SG-Question-Answer-Area">
						<input type="number" onChange={this.onInputChanged} value={this.props.answer} />
					</div>
					);
				break;
			case 'checkbox':
				var answerBoxes = [];
				var counter = 0, maxPerCol = 4;
				var answerColumns = [];
				for(var aKey in this.props.possible_answers) {
					var thisAnswer = this.props.possible_answers[aKey], 
						checked = (this.props.answer.indexOf(thisAnswer) > -1) ? 'checked' : false;
					var thisBox = (
						<div key={aKey} className="SG-Question-Checkbox">
							<input type="checkbox" name={this.props.dataId} id={thisAnswer} onClick={this.onInputChanged} defaultChecked={checked} />
							<label htmlFor={thisAnswer} >{thisAnswer}</label>
						</div>
						);
					answerBoxes.push(thisBox);
					counter++;
					if(counter >= maxPerCol || counter + (maxPerCol * answerColumns.length) === this.props.possible_answers.length) {
						answerColumns.push((<div key={counter + maxPerCol * answerColumns.length}className="SG-Question-Checkbox-Column">{answerBoxes}</div>));
						answerBoxes = [];
						counter = 0;
					}
				}
				answerContent = (
					<div className="SG-Question-Answer-Area">
						{answerColumns}
					</div>
					);
				break;
			case 'file':
				var attachText = (this.props.answer && typeof this.props.answer === 'object') ? this.props.answer.name + ' ' + this.getReadableFileSizeString(this.props.answer.size) : 'Attach File';
				var url = (StringUtils.isFilled(this.props.url)) ? (<a href={this.props.url}>Current Plan</a>) : '';
				answerContent = (
					<div className="SG-Question-Answer-Area">
						<input type="file" id={"file-upload-" + this.props.dataId} onChange={this.onFileSelect} style={{display: "none"}} />
						<button className="SG-Question-File-Upload" onClick={this.onInputChanged}>
							<img src={process.env.PUBLIC_URL + "images/paperclip.png"} alt={'paper clip'}/>
						</button>
						<div className="Attach-Text">
							{attachText}
							<br />
							{url}
						</div>
					</div>
					);
				break;
			default:
				break;

		}

		var content = (
			<div className="SG-Question-Block">
				<div className="SG-Question-Text">{this.props.question_num + ") " + this.props.question_text}</div>
				{answerContent}
			</div>
			);

		return content;
	}
}

export default SGQuestion;